// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';
import Login from '@/views/Login.vue';
import Home from '@/views/Home.vue';
import CreateVideo from '@/views/CreateVideo.vue';
import ImageCloning from '@/views/ImageCloning.vue';
import VoiceCloning from '@/views/VoiceCloning.vue';
import VoiceSynthesis from '@/views/VoiceSynthesis.vue';
import DigitalWorks from '@/views/DigitalWorks.vue';
import SuperAssistant from '@/views/SuperAssistant.vue';
import UserProfile from '@/views/UserProfile.vue';
import { auth } from '@/utils/auth.js'; // 引入 auth.js
import CozeSuper from '@/views/CozeSuper.vue';

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    redirect: '/home/image-cloning', // 设置默认子路由
    children: [
      {
        path: 'create-video',
        name: 'CreateVideo',
        component: CreateVideo,
      },
      {
        path: 'image-cloning',
        name: 'ImageCloning',
        component: ImageCloning,
      },
      {
        path: 'voice-cloning',
        name: 'VoiceCloning',
        component: VoiceCloning,
      },
      {
        path: 'voice-synthesis',
        name: 'VoiceSynthesis',
        component: VoiceSynthesis,
      },
      {
        path: 'digital-works',
        name: 'DigitalWorks',
        component: DigitalWorks,
      },
      {
        path: 'super-assistant',
        name: 'SuperAssistant',
        component: SuperAssistant,
      },
      {
        path: 'user-profile',
        name: 'UserProfile',
        component: UserProfile,
      },

      // 其他路由
      {
        path: 'coze-super', // 新增路由路径
        name: 'CozeSuper',
        component: CozeSuper, // 对应的组件
      },

    ],
    meta: { requiresAuth: true }, // 需要认证的路由
  },
  // 其他路由，例如 404 页面
  { path: '/:pathMatch(.*)*', redirect: '/login' },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 添加全局前置守卫，检查是否需要认证
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!auth.getStoredUser();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next('/login');
    } else {
      next();
    }
  } else {
    if (isLoggedIn && to.path === '/login') {
      next('/home/image-cloning'); // 已登录用户访问登录页，重定向到默认页面
    } else {
      next();
    }
  }
});

export default router;
